export const baseURL = "/api";
export const timeout = 60000;//60s
export const headers = {}

